import { monotonicFactory, ulid } from 'ulid';
/**
 * Minden azonosito ULID: idorendben rendezheto, es a kliens is tud generalni
 * (ez kell az optimista UI-hoz es a `client_msg_id` alapu deduplikaciohoz).
 */
export const newId = () => ulid();
/** Azonos ezredmasodpercen belul is szigoruan novekvo sorrend (koteges beszurashoz). */
export const monotonicId = monotonicFactory();
const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/;
export const isId = (value) => typeof value === 'string' && ULID_RE.test(value);
//# sourceMappingURL=ids.js.map